<div class="w-100 d-flex justify-content-between py-6">
  <hr class="w-100">
  <h1 class="w-25 text-center" translate>search.formation</h1>
  <hr class="w-100">
</div>
<div class="d-flex flex-wrap justify-content-center gap-8">
  <div *ngFor="let formation of data$ | async as formations"
    class="formation-card-body bg-white  p-0 d-flex flex-column ">
    <div [routerLink]="'/formation/'+formation?.id" class="media custom-image cursor-pointer "
      [style.backgroundImage]="'url(' + formation?.image + ')'">

    </div>
    <h3 *ngIf="getKeys(formation?.highlights).includes('title')"
      class="title-line text-center pt-4 cursor-pointer  highlighted"
      [innerHTML]="sanitize(formation.highlights.title)"></h3>
    <h3 *ngIf="!getKeys(formation?.highlights).includes('title')" class="title-line text-center pt-4 cursor-pointer ">
      {{formation?.title}}
    </h3>
    <ng-container *ngIf="showDetails">
      <p *ngIf="getKeys(formation?.highlights).includes('description')" class="text-muted fs-6 px-2 highlighted"
        [innerHTML]="sanitize(formation.highlights.description)"></p>
      <p *ngIf="!getKeys(formation?.highlights).includes('description')" class="text-muted fs-6 px-2">
        {{formation?.description ? formation?.description : 'search.no_description' | translate }}
      </p>
    </ng-container>
  </div>
</div>
